import { CalculationErrorKeynameEnum } from '../../enums/calculations/calculation-error-keyname.enum';
import { BaseError } from '../base.error';

export class CalculationError extends BaseError {
  errorType: string;

  calculationErrorKeyname: CalculationErrorKeynameEnum;

  targetOptionProperty?: string;

  targetOptionClass?: Function;

  value?: any;

  constructor(calculationErrorKeyname: CalculationErrorKeynameEnum, targetOptionProperty?: string, targetOptionClass?: Function, value?: any) {
    super(calculationErrorKeyname);
    this.errorType = CalculationError.name;
    this.calculationErrorKeyname = calculationErrorKeyname;
    this.targetOptionProperty = targetOptionProperty;
    this.targetOptionClass = targetOptionClass;
    this.value = value;

    // Set the prototype explicitly.
    // As specified in the documentation in TypeScript
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, CalculationError.prototype);
  }
}
